module.exports = __webpack_public_path__ + "img/japan-kanji-letter.aedfc8cc.svg";